<template lang="pug">
  //- SECTION TO APPEAR IN WELLNESS CHALLENGE BUILDER
  ul(v-if="isChallengeBuilder")
    li.is-flex.mb-2(
      v-for="metric in challengeMetrics"
      v-if="isMetricOn(metric) && (metric!='blog' && metric!='question' && metric!='photos')"
      )
      BIcon(icon="check-circle" type="is-green-light") 
      div.is-size-6.ml-2 {{ metricText(metric) }}
  //- SECTION TO APPEAR IN CHALLENGE BUILDER DETAILS MODAL
  ul.p-1#WellnessChallengePointsBreakDownDetails(v-else)
    li.is-flex.mb-2(v-if="isMetricOn(pointsForJournalSteps)")
      BIcon.pr-3(icon="check-circle" type="is-teal")
      div
        .is-size-6.is-family-secondary {{ isMetricOn(pointsForJournalSteps) }} challenge points/day
        .is-size-6.has-text-grey.is-family-primary Logging Physical Activity (Steps and/or Activities)
    li.is-flex.mb-2(v-if="isMetricOn(pointsForWellnessMood)")
      BIcon.pr-3(icon="check-circle" type="is-teal")
      div
        .is-size-6.is-family-secondary {{ isMetricOn(pointsForWellnessMood) }} challenge points/day
        .is-size-6.has-text-grey.is-family-primary Logging Mood metrics
    li.is-flex.mb-2(v-if="isMetricOn(pointsForWellnessSleep)")
      BIcon.pr-3(icon="check-circle" type="is-teal")
      div
        .is-size-6.is-family-secondary {{ isMetricOn(pointsForWellnessSleep) }} challenge points/day
        .is-size-6.has-text-grey.is-family-primary Logging Sleep metrics
    li.is-flex.mb-2(v-if="isMetricOn(pointsForWellnessWater)")
      BIcon.pr-3(icon="check-circle" type="is-teal")
      div
        .is-size-6.is-family-secondary {{ isMetricOn(pointsForWellnessWater) }} challenge points/day
        .is-size-6.has-text-grey.is-family-primary Logging Water metrics
    li.is-flex.mb-2(v-if="isMetricOn(pointsForWellnessWeight)")
      BIcon.pr-3(icon="check-circle" type="is-teal")
      div
        .is-size-6.is-family-secondary {{ isMetricOn(pointsForWellnessWeight) }} challenge points/week
        .is-size-6.has-text-grey.is-family-primary Logging Weight metrics
    li.is-flex.mb-2(v-if="isMetricOn(pointsForWellnessNutrition)")
      BIcon.pr-3(icon="check-circle" type="is-teal")
      div
        .is-size-6.is-family-secondary {{ isMetricOn(pointsForWellnessNutrition) }} challenge points/day
        .is-size-6.has-text-grey.is-family-primary Logging Nutrition metrics
    li.is-flex.mb-2(v-if="isMetricOn(pointsForWellnessMindfulness)")
      BIcon.pr-3(icon="check-circle" type="is-teal")
      div
        .is-size-6.is-family-secondary {{ isMetricOn(pointsForWellnessMindfulness) }} challenge points/day
        .is-size-6.has-text-grey.is-family-primary Logging Mindfulness metrics
    li.is-flex.mb-2(v-if="isMetricOn(pointsForWellnessHeart)")
      BIcon.pr-3(icon="check-circle" type="is-teal")
      div
        .is-size-6.is-family-secondary {{ isMetricOn(pointsForWellnessHeart) }} challenge points/day
        .is-size-6.has-text-grey.is-family-primary Logging Heart metrics
    li.is-flex.mb-2(v-if="isMetricOn(pointsForJournalPhoto) || isMetricOn(pointsForJournalText)")
      BIcon.pr-3(icon="check-circle" type="is-teal")
      div
        .is-size-6.is-family-secondary  4 challenge points/day
          span(v-if="!isCustomWellness") *
        .is-size-6.has-text-grey.is-family-primary Journal Entry, uploading a photo (3 points) and written entry (1 point)
    li.is-flex.mb-2(v-if="isMetricOn(pointsForQuestion)")
      BIcon.pr-3(icon="check-circle" type="is-teal")
      div
        .is-size-6.is-family-secondary {{ isMetricOn(pointsForQuestion) }} challenge points per question
          span(v-if="!isCustomWellness") *
        .is-size-6.has-text-grey.is-family-primary Correctly answering a {{ isMetricOn(pointsForQuestion) === 10 ? "weekly" : "bi-weekly" }} question
    .pt-4.is-size-7(v-if="!isCustomWellness") * May not apply to your challenge

</template>

<script>
import { mapGetters } from "vuex";
import { pointsMixin } from "@/mixins/pointsMixin";

export default {
  name: "WellnessChallengePointsBreakDownDetails",

  mixins: [pointsMixin],

  props: {
    // * * *
    // Either map.metricsTracking or challenge.metricsTracking
    // * * *
    metricsTracking: {
      type: Object,
      required: true
    },
    // * * *
    // Either map.isCustomWellnessChallenge or challenge.isCustomWellness
    // * * *
    isCustomWellness: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters("challengeBuilder", ["activeStep"]),

    isChallengeBuilder() {
      return (
        this.$route.name == "ChallengeCenterBuilder" && this.activeStep > 1
      );
    },

    challengeMetrics() {
      return this.$data;
    }
  },

  methods: {
    isMetricOn(metric) {
      return this.metricsTracking[metric];
    },

    metricText(metric) {
      if (metric === "entries") {
        return "Steps";
      }
      if (metric === "blog") {
        return "Journal Entries";
      }
      if (metric === "question") {
        return "Questions";
      } else {
        return metric[0].toUpperCase() + metric.slice(1);
      }
    }
  }
};
</script>

<style lang="sass" scoped>
#WellnessChallengePointsBreakDownDetails
  list-style: none
</style>
